import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  data: [],
  customersLoading: false,
  customersLoaded: false,
};

const customerSlice = createSlice({
  name: "customers",
  initialState: INITIAL_STATE,
  reducers: {
    reset() {
      return INITIAL_STATE;
    },
    setCustomers(state, { payload }) {
      state.data = payload || [];
    },
    setCustomersLoading(state, { payload }) {
      state.customersLoading = payload;
    },
    setCustomersLoaded(state, { payload }) {
      state.customersLoaded = payload;
    },
  },
});

export const { reset, setCustomers, setCustomersLoading, setCustomersLoaded } =
  customerSlice.actions;

export default customerSlice;
